import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';
import ProfileCard from '../ui/ProfileCard';
import CardState from '../ui/CardState';

const STATUS_LABEL = {
  pending: 'Pending', approved: 'Approved', provisioning: 'Provisioning',
  active: 'In progress', publish_requested: 'In review', published: 'Published', rejected: 'Rejected',
};

export default function AppRequestsTab({ userId, isMemberView }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    const url = isMemberView
      ? `${API_BASE_URL}/api/profile/${userId}/app-requests`
      : `${API_BASE_URL}/api/app_requests/mine`;
    (async () => {
      try {
        const r = await axios.get(url, { withCredentials: true });
        if (!active) return;
        setItems(r.data.app_requests || r.data || []);
      } catch {
        if (active) setError(true);
      }
    })();
    return () => { active = false; };
  }, [userId, isMemberView]);

  const count = Array.isArray(items) && items.length ? ` · ${items.length}` : '';
  if (error || !items || !items.length) {
    return (
      <ProfileCard title="App requests" span>
        {error && <CardState kind="error" thing="app requests" />}
        {!error && !items && <CardState kind="loading" label="Loading app requests" />}
        {!error && items && !items.length && <CardState kind="empty">No app requests yet.</CardState>}
      </ProfileCard>
    );
  }

  return (
    <ProfileCard title={`App requests${count}`} span>
      <div className="profile-app-grid">
        {items.map((a) => {
          const toolCount = Array.isArray(a.tools) ? a.tools.length : null;
          return (
            <article key={a.id} className="profile-app-card">
              <div className="profile-app-card__top">
                <span className={`profile-status profile-status--${a.status}`}>{STATUS_LABEL[a.status] || a.status}</span>
                <span className={`profile-role-tag ${a.is_creator ? 'is-creator' : ''}`}>
                  {a.is_creator ? 'Creator' : 'Collaborator'}
                </span>
              </div>
              <h3 className="profile-app-card__name">
                {isMemberView ? a.name : <Link to={`/build-app/${a.id}`}>{a.name}</Link>}
              </h3>
              {a.description && <p className="profile-app-card__desc">{a.description}</p>}
              <p className="profile-app-card__meta">
                {toolCount != null ? `${toolCount} tool${toolCount === 1 ? '' : 's'}` : ''}
                {a.is_published ? ' · Published to catalog' : ''}
              </p>
            </article>
          );
        })}
      </div>
    </ProfileCard>
  );
}
